import * as React from 'react';
import { observer } from 'mobx-react';
import { lightable, lighted, LightningId, LightningProps } from 'owa-lightning-v2';
import strings from 'owa-strings/owa-mail-strings';
import { IImageProps } from 'office-ui-fabric-react/lib/Image';
import { IButtonProps, ButtonType } from 'office-ui-fabric-react/lib/Button';
import { TeachingBubble } from 'office-ui-fabric-react/lib/TeachingBubble';
import { getModuleUrl } from './utils/getModuleUrl';
import WebSessionType from 'owa-service/lib/contract/WebSessionType';
import { getIsDarkTheme } from 'owa-fabric-theme';
import getPackageBaseUrl from 'owa-session-store/lib/actions/getPackageBaseUrl';
import { resolve as urlResolve } from 'url';

let styles = require('./AddCloudCacheAccountCallout.scss');

const GmailIcon = 'resources/images/cloudCache/gmailIllustrations-01.svg';
const GmailIconDarkMode = 'resources/images/cloudCache/gmailIllustrations-02.svg';

export interface AddCloudCacheAccountCalloutProps extends LightningProps {
    lid: LightningId;
    target: () => HTMLElement;
}

@observer
@lightable
export default class AddCloudCacheAccountCallout extends React.Component<
    AddCloudCacheAccountCalloutProps,
    {}
> {
    render() {
        let addAccountButtonProps: IButtonProps = {
            buttonType: ButtonType.primary,
            children: strings.AddButtonText,
            onClick: () => this.addAccount(true),
        };

        let notNowButtonProps: IButtonProps = {
            buttonType: ButtonType.primary,
            children: strings.NotNowButtonText,
            onClick: () => this.onClose(false),
        };

        let imageProps: IImageProps = {
            src: urlResolve(getPackageBaseUrl(), getIsDarkTheme() ? GmailIconDarkMode : GmailIcon),
        };

        return (
            <TeachingBubble
                calloutProps={{
                    beakWidth: 15,
                    preventDismissOnLostFocus: true,
                    preventDismissOnScroll: true,
                    className: styles.teachingBubble,
                }}
                illustrationImage={imageProps}
                targetElement={this.props.target()}
                hasCloseIcon={true}
                onDismiss={() => this.onClose(false)}
                hasSmallHeadline={true}
                isWide={true}
                headline={strings.FeaturePromotionCalloutTitle}
                primaryButtonProps={addAccountButtonProps}
                secondaryButtonProps={notNowButtonProps}>
                {strings.FeaturePromotionCalloutDescription}
            </TeachingBubble>
        );
    }

    private addAccount = (enabled: boolean) => {
        window.open(getModuleUrl(WebSessionType.GMail), '_blank');
        this.onClose(true);
    };

    private onClose = (enabled: boolean) => {
        lighted(this.props.lid, enabled ? 'Primary' : 'Secondary');
    };
}
